module.exports = __webpack_public_path__ + "assets/facebook-chat-plugin.48c7c456.svg";